// Global Instructions Rule Applied!

import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Button from '../../Button.jsx'

// Same transparent-on-gradient treatment as ExportToolbarButton — see
// docs/FRONTEND_DESIGN_PATTERNS.md.
const TOOLBAR_PDF_CLASS =
  '!border-0 !shadow-none !bg-transparent !text-white hover:!bg-white/10 hover:!text-white [&_.ant-btn-icon]:!text-white'

export interface DownloadPdfToolbarButtonProps {
  onClick: () => void | Promise<void>
  loading?: boolean
  disabled?: boolean
  /** Overrides the label, e.g. 'Download 12 PDFs' for a multi-report run. */
  label?: string
}

/**
 * PDF download control for the blue gradient ViewToolbar.
 *
 * Deliberately not ExportToolbarButton: that control means "export this grid to
 * Excel" everywhere else in the app, and reusing it for a document PDF would
 * make the toolbar vocabulary ambiguous. Same styling, different icon and verb.
 */
export default function DownloadPdfToolbarButton({
  onClick,
  loading = false,
  disabled = false,
  label = 'Download PDF'
}: DownloadPdfToolbarButtonProps) {
  return (
    <Button
      variant='default'
      type='text'
      size='small'
      icon={<FontAwesomeIcon icon={faFilePdf} />}
      className={TOOLBAR_PDF_CLASS}
      onClick={() => {
        void onClick()
      }}
      loading={loading}
      disabled={disabled}
    >
      {label}
    </Button>
  )
}
